import React, { FunctionComponent } from 'react';
import { Box, Skeleton, Stack } from '@monorepo/nova-ui';
import { SKELETON_CONFIG } from '../constants';

export const LoadingState: FunctionComponent = () => {
  return (
    <Stack gap={3}>
      <Box>
        <Stack gap={2}>
          {[...Array(SKELETON_CONFIG.ROWS_COUNT)].map((_, index) => (
            <Stack
              key={index}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Skeleton
                variant="text"
                width={SKELETON_CONFIG.LABEL_WIDTH}
                height={20}
              />
              <Skeleton
                variant="text"
                width={SKELETON_CONFIG.VALUE_WIDTH}
                height={20}
              />
            </Stack>
          ))}
        </Stack>
      </Box>
      <Skeleton variant="rectangular" height={SKELETON_CONFIG.BUTTON_HEIGHT} />
    </Stack>
  );
};
